import styled from "styled-components";
import { colors } from "../../utils";

export const Wrapper = styled.div`
  display: flex;
  padding-top: 20px;
  overflow-y: auto;
  height: 84vh;
`;

export const NavbarWrapper = styled.div``;

export const LeftColumn = styled.div`
  height: 100%;
  width: 22%;
  padding: 0px 1%;
`;

export const CenterColumn = styled.div`
  height: 100%;
  width: 56%;
  padding: 0px 1%;
`;

export const RightColumn = styled.div`
  height: 100%;
  width: 22%;
  display: flex;
  flex-direction: column;
  padding: 0px 1%;
`;

export const Tab = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.primary};
  height: 8vh;
  padding-top: 10px;
`;

export const TabItem = styled.div`
  cursor: pointer;
  margin: 10px;
  margin-right: 30px;
  color: white;
  padding: 10px;
  display: flex;
  align-items: center;
`;

export const TabIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 5px;
`;
